/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'organization-data-analytics': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M2.5 1.25H1.25V17.5c0 .69.56 1.25 1.25 1.25h16.25V17.5H2.5V1.25zm16.25 4.375h-4.375v1.25h2.244l-4.744 4.744L9.194 8.93a.625.625 0 00-.888 0L3.75 13.494l.881.881 4.119-4.119 2.681 2.688a.625.625 0 00.888 0L17.5 7.756V10h1.25V5.625z"/>'
  }
})
